import {
  LOGIN,
  LOGIN_SOCIAL_CALLBACK,
  LOGIN_SOCIAL_FAIL,
  LOGIN_SOCIAL_TWO_FACTOR,
  PASSWORD_RESET,
  PASSWORD_RESET_TOKEN,
  ACCOUNT_RECOVERY_REDEEM,
  ACCOUNT_RECOVERY_CANCEL,
  SIGNUP,
  SIGNUP_INVITED,
} from '@/routerNames';

export const authRoutes = [
  SIGNUP,
  LOGIN,
  LOGIN_SOCIAL_CALLBACK,
  LOGIN_SOCIAL_FAIL,
  LOGIN_SOCIAL_TWO_FACTOR,
  PASSWORD_RESET,
  PASSWORD_RESET_TOKEN,
  ACCOUNT_RECOVERY_REDEEM,
  ACCOUNT_RECOVERY_CANCEL,
  SIGNUP_INVITED,
];
